import { render, staticRenderFns } from "./LockedServiceAccountsPage.vue?vue&type=template&id=8f9ab380&scoped=true"
import script from "./LockedServiceAccountsPage.vue?vue&type=script&lang=ts"
export * from "./LockedServiceAccountsPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f9ab380",
  null
  
)

export default component.exports